module.exports = __webpack_public_path__ + "media/ring.f7199b8b.mp3";